import { memo, useState } from 'react';
import Slider from '@mui/material/Slider';

export type RangeValues = [number, number];

export type RangeProps = {
  initValue: RangeValues;
  limitValues: RangeValues;
  unit: string;
  valueLabelDisplay?: 'auto' | 'on' | 'off';
  onChangeCommitted?: (event: React.SyntheticEvent | Event, value: number | number[]) => void;
};

const RangeFn = (props: RangeProps) => {
  const { initValue, limitValues, unit, valueLabelDisplay, onChangeCommitted } = props;
  const [min, max] = limitValues;
  const [value, setValue] = useState(initValue);

  const handleChange = (event: Event, newValue: number | number[]) => {
    setValue(newValue as RangeValues);
  };

  const handleChangeCommitted = (event: React.SyntheticEvent | Event, newValue: number | number[]) => {
    onChangeCommitted && onChangeCommitted(event, newValue);
  };

  const valueLabelFormat = (value: number): string => {
    return `${value} ${unit}`;
  };

  return (
    <Slider
      value={value}
      min={min}
      max={max}
      onChange={handleChange}
      onChangeCommitted={handleChangeCommitted}
      valueLabelFormat={valueLabelFormat}
      valueLabelDisplay={valueLabelDisplay}
    />
  ) as React.ReactElement;
};

const Range = memo(RangeFn);

export default Range;
export { Range };
